import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterOutlet],
    template: `<router-outlet></router-outlet>`,
    styles: []
})
export class AppComponent implements OnInit {
    title = 'Eliquis PAP';

    constructor(private translate: TranslateService) {}

    ngOnInit(): void {
        this.translate.use('en');
    }
}
